<template>
	<div class="newdetail">
		<div class="img">
			<img :src="banner"/>
		</div>
		<!--路径-->
		<div class="container">
			<div class="path">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				  	<el-breadcrumb-item :to="{ path: '/NewCenter' }">新闻中心</el-breadcrumb-item>
				  	<el-breadcrumb-item>{{data.title}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			
			<!--内容-->
			<div class="content clearfix">
				<div class="content-title">
					<h1>{{data.title}}</h1>
					<span style="">{{data.addtime}}</span>
					<span class="view">浏览量：{{data.clickNum}}</span>
				</div>
				
				<div class="content-lists" v-html="data.content"></div>
				
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		name:'',
		components:{},
		data(){
			return{
				msg:'newcenter',
				data:'',
				banner:''
			}
		},
		methods:{
			getDetail(){
				var id = this.$route.query.id;
				this.axios({
					method: 'get',
					url: this.GLOBAL.newsDetailApi+id,
					data: {}
				})
				.then((res) => {
					this.data = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'3',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner3;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getDetail();
			this.getBanner();
		}

	}
</script>

<style lang="less" scoped="scoped">
.newdetail{
	.img{
		width:100%;
		height:350px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.path{
		margin-top: 20px;
		margin-bottom: 20px;
		i{
			font-size: 20px;
		}
		span{
			color: #00A0FF;
		}
		.news{
			width: 100px;
			height: 40px;
			color: forestgreen;
			margin-left: 5px;
			margin-right: 5px;
		}
		.a{
			color: #000000;
			text-decoration: underline;
		}
	}
		.content{
			margin-top: 70px;
			margin-bottom: 70px;
			box-shadow:0px 0px 10px #dfdfdf;
			padding:30px;
			.content-title{
				width: 100%;
				border-bottom:1px solid #eee;
				padding-bottom: 10px;
				h1{
					font-size: 30px;
					line-height:40px;
					text-align: center;
					margin-bottom: 20px;
					padding-top: 20px;
					i{
						color: #00A0FF;
						margin-right: 30px;
					}
				}
				span{
					color:#696969;
					line-height:18px;
					font-size:12px;
					padding:10px;
				}
				.view{
					float: right;
				}
			}
			.content-lists{
				margin-top: 40px;
				p{
					font-size: 18px;
					padding: 8px;
				}
				img{
					margin-top: 30px;
					width: 90%;
					height: 500px;
					margin-bottom: 50px;
				}
			}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/NewCenter/NewDetail.vue